// import httpClient from 'httpClient'
import { mapGetters } from 'vuex'
// import $ from 'jquery'
// import vuetify from 'vuetify'

export default {
  name: 'dashboard',
  data: () => {
    return {
      dismissSecs: 4,
      dismissCountDownSuccess: 0,
      dismissCountDownDanger: 0,
      errors: [],
      successMessage: ''
    }
  },
  created () {
  },
  computed: mapGetters([
    'isLogged'
  ]),
  methods: {
    countDownChangedSuccess (dismissCountDownSuccess) {
      this.dismissCountDownSuccess = dismissCountDownSuccess
    },

    countDownChangedDanger (dismissCountDownDanger) {
      this.dismissCountDownDanger = dismissCountDownDanger
    },

    showSuccess () {
      this.dismissCountDownSuccess = this.dismissSecs
    },

    showError () {
      this.dismissCountDownDanger = this.dismissSecs
    }
  }
}
